import { Component, input } from '@angular/core';
import { DsmSpecsLotAddendumViewComponent } from './dsm-specs-lot-addendum-view/dsm-specs-lot-addendum-view.component';

@Component({
  selector: 'dsm-build-spec-options',
  templateUrl: './dsm-build-spec-options.component.html',
  host: { class: 'flex flex-col flex-1 overflow-hidden' },
  imports: [DsmSpecsLotAddendumViewComponent]
})
export class DsmBuildSpecOptionsComponent {
  buildSpecId = input.required<string>();
}
